// Lab SVG font sizes (px) — mirrors --font-sm / --font-base / --font-lg at 90% of original
// Use these for inline styles and SVG presentation attributes in math/geometry labs
// where CSS variables cannot be used directly.
export const FONT = {
  sm:   10,  // was 11–12: vertex labels, angle markers, small SVG text
  base: 12,  // was 13–14: descriptions, table cells, sidebar body
  lg:   14,  // was 16:    section headings (Layers, Presets, Insights, etc.)
};
